import React, { useState } from "react";
import Button from "react-bootstrap/Button";

const InstructionComponent = () => {
  return (
    <div style={{maxWidth:'330px'}}>
			<div style={{textAlign:'center'}} title="Instruction">
				<p>1) Please go to Settings, and Set Your CMIX Folder Location First</p>
				<p>2) For sending sounds and scores, please click the sender button in Settings first, then input player number and receiver's ip address first</p>
				<p>3) For receiving, click the receiver button. Please make sure your server app is running first and refresh your webpage if it's showing only one port in the "receive stats" window</p>
                <p>4) To send sounds and scores, create new components from the top bar</p>
                <p>5) In "Reveive Stats" window, click the port to stop playing the sound at that port</p>
				<p>6) For online streaming, a) both the sender and receiver creates a Stream Online component, b) Both check the video streaming box if you want to send/receive video, and then click start audio/video streaming, c) The sender clicks the create call (offer) button to create the key and sends that key to the receiver, d) The receiver pastes the key into the box and clicks answer.</p>
			</div>
		</div>
  );
};

export default InstructionComponent;
